<template>
  <div class="add-type-select-option">
    <draggable v-model='selectList' @start='handleStart' @end='handleEnd'>
      <transition-group name="list" tag="p">
        <div class='s_item' v-for='(item,index) in selectList' :key='item.optionName' >
          <div class='s_item_left'>
            <img src="/static/icon/drag_mark.png" alt="" style="margin-left:5px;" class='s_draggable'>
            <span class='s_chose'
            :style='{background:item.color,color:item.color?"#fff":"",border:item.color?"":"1px solid #ddd"}'
            :title="item.optionName"
            >
              {{item.optionName}}
            </span>
            <span class='clickFullColor' v-if='colorFull'>
              <el-color-picker
                v-model="item.color"
                show-alpha
                @change = "handleColorChange($event,item)"
                :predefine="predefineColors">
              </el-color-picker>
            </span>
          </div>
          <div class='s_item_right'>
            <span class='default' v-if='item.isDefault'  @click='handleIsDefault(item,false)'>默认</span>
            <span class='is_default' v-else @click='handleIsDefault(item,true)'>设为默认</span>
            <span class='edit' @click='handleEdit(item)'>编辑</span>
            <span class='delete' @click='handleDelete(item,index)'>删除</span>
          </div>
        </div>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
   import draggable from 'vuedraggable'
   export default {
     props:{
       colorFull:[Boolean],
       isChoice:{
         type:[String,Number],
         default:"0"
       }
     },
     components:{
       draggable
     },
     data() {
       return {
         selectList:[],
          color:"",
          predefineColors: [
           '#ff4500',
           '#ff8c00',
           '#ffd700',
           '#90ee90',
           '#00ced1',
           '#1e90ff',
           '#c71585',
           'rgba(255, 69, 0, 0.68)',
           'rgb(255, 120, 0)',
           'hsv(51, 100, 98)',
           'hsva(120, 40, 94, 0.5)',
           'hsl(181, 100%, 37%)',
           'hsla(209, 100%, 56%, 0.73)',
           '#c7158577'
         ],
       }
     },
     watch:{
       colorFull(val) {
         if(val) {
         	if(this.selectList.length) {
         		this.selectList.forEach(i=>{
         			i.color = i.color?i.color:this.randomColor();
         		})
         	}
         }else {
         	if(this.selectList.length) {
         		this.selectList.forEach(i=>{
         			i.color = "";
         		})
         	}
         }
         // this.$emit('getList',this.selectList,this.selectList)
       }
     },
     methods:{
       // 颜色改变
       handleColorChange(e,row) {
         this.$emit('getList',this.selectList,[row])
       },
       // 随机颜色函数
       randomColor(){
       	let r,g,b,a;
       	r = Math.floor(Math.random()*256);
       	g = Math.floor(Math.random()*256);
       	b = Math.floor(Math.random()*256);
       	a = 0.8;
       	return 'rgba(' + r +',' + g + ',' + b + ',' + a +")";
       },
      // 设为默认
      handleIsDefault(row,status) {
      	if(this.isChoice === "0") {
      		this.selectList.forEach(i=>{
      			i.isDefault = false;
      		})
      		row.isDefault = status;
      	}else {
      		row.isDefault = status;
      	}
        this.$emit('getList',this.selectList,[row])
      },
       // 编辑下拉 列表
       handleEdit(row) {
       	if(!row.id) {
       		this.$prompt('请输入修改名称', '', {
                 confirmButtonText: '确定',
                 cancelButtonText: '取消',
                 inputPattern: /\S/,
                 inputValue: row.optionName,
                 closeOnClickModal:false,
                 inputErrorMessage: '名称不能为空！'
               }).then(({ value }) => {
               	row.optionName = value;
               }).catch(() => {

               });
               this.$emit('getList',this.selectList,[row])
               return;
       	}
       	this.$http.post('custom/deleteCustomAndOption' , {id:row.id, type: "0"}).then(res=>{
       		if(res && res.data.code==1) {
       			if(res.data.data) {
       				this.$confirm('当前修改会将历史记录该项更新，是否继续修改并更新？', '提示', {
       			          confirmButtonText: '确定',
       			          cancelButtonText: '取消',
       			          type: 'warning'
       			        }).then(() => {
       			          	 this.$prompt('请输入修改名称', '', {
       					          confirmButtonText: '确定',
       					          cancelButtonText: '取消',
       					          inputPattern: /\S/,
       					          inputValue: row.optionName,
       					          closeOnClickModal:false,
       					          inputErrorMessage: '名称不能为空！'
       					        }).then(({ value }) => {
       					        	row.optionName = value;
                          this.$emit('getList',this.selectList,[row])
       					        }).catch(() => {

       					        });
       			        }).catch(() => {

       			        });
       			}else {
       				this.$prompt('请输入修改名称', '', {
       		          confirmButtonText: '确定',
       		          cancelButtonText: '取消',
       		          inputPattern: /\S/,
       		          closeOnClickModal:false,
       		          inputValue: row.optionName,
       		          inputErrorMessage: '名称不能为空！'
       		        }).then(({ value }) => {
       		        	row.optionName = value;
                    this.$emit('getList',this.selectList,[row])
       		        }).catch(() => {

       		        });
       			}
       		}
       	})
       },
       // 删除下拉选项
       handleDelete(row,index) {
       	if(row.id) {
       		this.$http.post('custom/deleteCustomAndOption' , {id:row.id, type: "0"}).then(res=>{
       			if(res&&res.data.code == 1) {
       				if(res.data.data) {
       					this.$confirm('删除后历史数据中有关该项也会被清除，是否删除？', '提示', {
       			          confirmButtonText: '确定',
       			          cancelButtonText: '取消',
       			          type: 'warning'
       			        }).then(() => {
       			        	this.selectList.splice(index,1);
                      this.deleteItem(row.id);
       			        }).catch(() => {

       			        });
       				}else {
                this.deleteItem(row.id);
       					this.selectList.splice(index,1);
       				}
       			}
       		})
       	}else {
       		this.selectList.splice(index,1);
       	}
       },
       // 执行删除操作
       deleteItem(id) {
         this.$http.post('custom/deleteOptin' , {id:id}).then(res=>{
       			if(res&&res.data.code == 1) {
               this.$message.success("删除成功！")
               this.$emit("refresh",true);
       			}
       		})
       },
       // 拖动开始
       handleStart(e){
       	e.item.style.background='#eee';
       	e.item.style.transform='translateX(0px)';
       	e.item.style.borderRadius ='5px';
       	e.item.style.opacity ='.5';
       },
       // 拖动结束
       handleEnd(e) {
       	e.item.style.background='';
       	e.item.style.transform='translateX(0px)';
       	e.item.style.borderRadius ='0px';
       	e.item.style.opacity ='1';
        this.$emit('sort',this.selectList);
       },

     }
   }
</script>

<style lang='less' scoped>

</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/dialogComponents/add-type-select-option.vue